import React from 'react';

import Myordertab from '../../usercomponents/Myordertab/Myordertab';
import Usrnav from '../../usercomponents/Usrnav/Usrnav';
import styles from './Myorders.module.css'
const Myorders = () => {
  

  return (

   <div  className={styles.opcontainer}>
   <div className="nav-wrapper">
                <Usrnav />
              </div>
<Myordertab/>
   </div>
  )
      
};

export default Myorders;
